import { PermissionResource } from '@entities/client/permission';

import { requirePermission } from '../../../require-permission';

export const usersLoader = requirePermission(PermissionResource.ClientUsers);
